import { createSlice } from "@reduxjs/toolkit";

export const liveAgentSlice = createSlice({
    name: "liveAgent",
    initialState: {
        connectedLiveAgent: false,
        connectingLiveAgent: false,
        genesysDetails: null,
        queuePos: null,
        queueScheduler: null,
        retryLiveAgent: false,
        liveAgentUnavailable: false,
    },
    reducers: {
        setConnectedLiveAgent: (state, action) => {
            state.connectedLiveAgent = action.payload;
        },
        setConnectingLiveAgent: (state, action) => {
            state.connectingLiveAgent = action.payload;
        },
        setGenesysDetails: (state, action) => {
            state.genesysDetails = action.payload;
        },
        setQueuePos: (state, action) => {
            state.queuePos = action.payload;
        },
        clearQueuePos: (state) => {
            state.queuePos = null;
        },
        setQueueScheduler: (state, action) => {
            state.queueScheduler = action.payload;
        },
        clearQueueScheduler: (state) => {
            state.queueScheduler = null;
        },
        setRetryLiveAgent: (state, action) => {
            state.retryLiveAgent = action.payload;
        },
        setLiveAgentUnavailable: (state, action) => {
            state.liveAgentUnavailable = action.payload;
        },
    }
});

export const { setConnectedLiveAgent, setConnectingLiveAgent, setGenesysDetails, setQueuePos, clearQueuePos, setQueueScheduler, clearQueueScheduler, setRetryLiveAgent, setLiveAgentUnavailable } = liveAgentSlice.actions;

export default liveAgentSlice.reducer;